/**
 * Centralized date-related labels for date pickers and validators
 * Uses Angular i18n $localize function for internationalization
 */

export const DATE_LABELS = {
  // Placeholders
  PLACEHOLDER: $localize`TT.MM.JJJJ`,

  // Validation errors
  REQUIRED: $localize`Dieses Feld ist erforderlich`,
  INVALID_FORMAT: $localize`Ungültiges Datum (TT.MM.JJJJ)`,
} as const;
